import { useState } from "react";

export function useAssetSelection() {
  const [selectedAssets, setSelectedAssets] = useState<number[]>([]);

  const handleAssetSelectionChange = (
    attachmentId: number,
    isSelected: boolean,
  ) => {
    setSelectedAssets((prev) =>
      isSelected
        ? [...prev, attachmentId]
        : prev.filter((id) => id !== attachmentId),
    );
  };

  const isAssetSelected = (attachmentId: number) =>
    selectedAssets.includes(attachmentId);

  return {
    clearSelection: () => setSelectedAssets([]),
    handleAssetSelectionChange,
    isAssetSelected,
    selectedAssets,
  };
}
